import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Filters from './filters'

const TopMatter = props => {
  const { activeLayers, layersDictionary } = props
  const hasFilterable = activeLayers.find(id => layersDictionary[id] ? layersDictionary[id].filterOnUnit : null)

  return (
    <div>
      { hasFilterable ? <Filters /> : null }
    </div>
  )
}

const mapStateToProps = state => ({
  activeLayers: state.userSettings.find(setting => setting.settingId === 1) ?
    state.userSettings.find(setting => setting.settingId === 1).valueArray : [],
  layersDictionary: state.layersDictionary,
  rightToolbarState: state.rightToolbarState
})

const mapDispatchToProps = state => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(TopMatter)
